<banner-outlet></banner-outlet>

<input type="checkbox" id="cl-nav-side" [(ngModel)]="navOpened" class="cl-nav-checkbox" checked="checked">
<nav class="cl-nav-side">
  <div class="cl-nav-backdrop" (click)="sideNavService.close()"></div>
  <div class="cl-nav-drawer">
    <div data-simplebar="data-simplebar">

      <!-- Account block as in the Video Toolkit side nav: name, email small beneath. Only castlabs
           accounts have an account page to link to. -->
      <a class="cl-nav-account"
         [attr.href]="portalIdp.getIdpName() === 'Castlabs' ? (prod ? 'https://account.castlabs.com/' : 'https://account.test.cs.castlabs.com/') + 'o/' + (organization())?.id : null">
        @if (userProfileService.name(); as name) {
          <p>{{ name }}</p>
          <p class="cl-p-small">{{ userProfileService.email() }}</p>
        } @else {
          <p>{{ userProfileService.email() }}</p>
        }
      </a>

      <a class="cl-nav-organization" [routerLink]="[{outlets: { overlay: ['organizations'] }}]"
         queryParamsHandling="preserve" routerLinkActive="active">
        <label>Organization</label>
        <div class="cl-nav-organization-name">
          @if (organization(); as org) {
            <p>{{ org.name }}</p>
            @if (org.parent_name) {
              <p>via {{ org.parent_name }}</p>
            }
          } @else {
            @if (organizations(); as orgs) {
              @if (orgs.length === 0) {
                <p>No organization</p>
              } @else {
                <p>Switch organization</p>
              }
            } @else {
              <p>Loading ...</p>
            }

          }

        </div>
      </a>

      @if (organization()) {
        @if (csNavEntries(); as navEntries) {
          <details class="cl-dropdown cl-dropdown-dark cl-dropdown-medium">
            <summary>
              <span>{{ NAV.CP.title }} </span>
              <p class="cl-subentry"> {{ NAV.CP.subtitle }}</p>
            </summary>
            @for (entry of navEntries; track entry.id) {
              <a class="cl-dropdown-item"
                 [href]="entry.url">
                <span>{{ entry.title }}</span>
                @if (entry.subtitle) {
                  <p class="cl-subentry">{{ entry.subtitle }}</p>
                }
              </a>
            }
          </details>
          <!-- The dropdown's own arrow: only together with the dropdown, else it hangs alone under
               "Switch organization". -->
          <div class="cl-dropdown-arrow"></div>
        }
      }
      @if (organization(); as org) {
        @if ('contentplatform:repository:Query/Folder' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'files'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Files</a>
        }
        @if ('contentplatform:repository:Query/Search' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'search'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Search</a>
        }
        @if ('contentplatform:workflow:Mutation/StartWorkflowDefault' | isAllowed:'contentplatform:asset:input.content_identifier/isrc://': organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'audioorder'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Audio Order</a>
        }
        <hr class="cl-nav-separator">
        @if ('contentplatform:workflow:PreviewEncode' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'previews'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Previews</a>
        }
        @if ('contentplatform:signiant:Query/Portals' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'signiant-portals'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Signiant Connectors</a>
        }
        @if ('contentplatform:aspera:Query/Endpoints' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'aspera-endpoints'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Aspera Connectors</a>
        }
        @if (('contentplatform:repository:Query/DesktopHosts' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/EditingWorkspaces' | isAllowedAnywhere: organization())) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'crd'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Remote Desktop</a>
        }
        @if (airlines() && airlines().length > 0) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'workflows'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Workflows</a>
        }
        @if (('contentplatform:repository:Query/Organization' | isAllowedAnywhere: organization()) ||
        ('contentplatform:signiant:Query/Portals' | isAllowedAnywhere: organization()) ||
        ('contentplatform:aspera:Query/Endpoints' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/Search' | isAllowedAnywhere: organization()) ||
        ('contentplatform:workflow:PreviewEncode' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/DesktopHosts' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/EditingWorkspaces' | isAllowedAnywhere: organization()) ||
        ('contentplatform:workflow:Mutation/StartWorkflowDefault' | isAllowed:'contentplatform:asset:input.content_identifier/isrc://': organization()) ||
        airlines() && airlines().length > 0) {
          <hr class="cl-nav-separator">
        }
      }


      <a [routerLink]="[{outlets: {overlay: ['whats-new']}}]" [relativeTo]="null"
         queryParamsHandling="preserve" routerLinkActive="active" class="cl-nav-item">What's New
        @if (whatsNew.hasUnseen()) {
          <span class="cl-badge cl-badge-sm cl-color-sea">New</span>
        }</a>

      <!-- Not .cl-a-external: that is for links in running text (nowrap + a 1em right margin), and on a
           full-width nav item the margin overflowed the drawer by 16 px (horizontal scrollbar). -->
      <a href="https://castlabs.atlassian.net/servicedesk/customer/portal/33" class="cl-nav-item"
         target="_blank" rel="noopener noreferrer">Help Center <i class="fas fa-external-link-alt" aria-hidden="true"></i></a>


      <!--
        Platform monitoring. Sits down here with the account-level items rather than up with the
        content navigation, because it is an operator view of the whole platform and not something you
        do to an organization's content. The crown marks it as an admin capability; the entry appears
        only where the policy grants it, so it is never a locked door.

        Shown whenever *any* of the user's organizations grants the action, and links to that one, so
        the entry does not appear and vanish as the user switches organization. Resolving which org
        that is cannot be a single policy check — see MonitoringAccessService.
      -->
      @if (monitoringAccess.organization(); as monitoringOrg) {
        <a [routerLink]="[{ outlets: { overlay: ['monitoring'] } }]"
           [relativeTo]="null"
           routerLinkActive="active"
           class="cl-nav-item cl-color-text-steel"> Monitoring <i class="fas fa-crown" aria-hidden="true"></i></a>
      }

      <hr class="cl-nav-separator">
      <!-- castlabs-ui's own dark-mode switch, as the library renders it: two sibling labels for #cl-mode-dark,
           only the one for the current mode shown. The checkbox is in app.component.html (app-wide, so the
           login page and /reports follow the theme too); clThemeSetup() binds it to cl_ui_settings.
           The labels must stay direct siblings in the nav, not wrapped: the library's "last item" bottom
           margin (ClNavSide/style.scss) matches a label followed by the other label as :last-child, which
           inside a wrapper is always true and leaves a gap wherever the switch sits. -->
      <!-- The library marks its labels aria-hidden and not focusable. Each label is the keyboard and
           screen-reader control instead (only the displayed one is reachable; the other is display:none),
           in the nav's tab order. Click, Space and Enter all click the checkbox, so clThemeSetup()'s change
           listener stays the one code path; a label's own click is prevented, as it would move focus to the
           far-away checkbox and scroll the page there. -->
      <label for="cl-mode-dark" class="cl-nav-item cl-nav-item-theme-light app-theme-switch it-theme-switch it-theme-switch-light" title="Switch"
             tabindex="0" role="switch" aria-label="Dark mode" [attr.aria-checked]="dark()"
             (click)="toggleTheme($event)" (keydown.space)="toggleTheme($event)" (keydown.enter)="toggleTheme($event)"><i class="far fa-sun fa-fw" aria-hidden="true"></i> Light mode </label>
      <label for="cl-mode-dark" class="cl-nav-item cl-nav-item-theme-dark app-theme-switch it-theme-switch it-theme-switch-dark" title="Switch"
             tabindex="0" role="switch" aria-label="Dark mode" [attr.aria-checked]="dark()"
             (click)="toggleTheme($event)" (keydown.space)="toggleTheme($event)" (keydown.enter)="toggleTheme($event)"><i class="far fa-moon fa-fw" aria-hidden="true"></i> Dark mode </label>

      <a href="#" (click)="doLogout()" role="button" class="cl-nav-item cl-color-text-steel it-signout"><i class="fas fa-fw fa-sign-out-alt" aria-hidden="true"></i> Sign out</a>

      <div class="cl-spacing-medium"></div>
    </div>
  </div>
</nav>
<div class="cl-main">
  <router-outlet name="overlay" #overlay="outlet"></router-outlet>
  @if (!overlay.isActivated) {
    <!-- Airlines are the usual reason to be here, but a content supplier has none by design and only
         ever browses/uploads into its own PO directories -- so file-browsing access also admits. -->
    @if (contextService.organization() == null || contextService.airlines() && contextService.airlines().length > 0 || contextService.canBrowseFiles()) {
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    } @else {
      <app-logo-area></app-logo-area>
      <main>
        <app-headline-section [title]="'Not Authorized'"></app-headline-section>
        <section class="cl-section cl-section-regular">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <p class="alert cl-alert-info" role="alert">You are not authorized to access your company's Content
                  Platform UI. Please contact your administrator!</p>
              </div>

            </div>
          </div>

        </section>

      </main>

    }
  }
</div>

<app-auto-logout></app-auto-logout>

